<script>
import apiHelper from "@/mixins/apiHelper.js";

export default {
  mixins: [
    apiHelper,
  ],
  emits: ['eventResizeChanged'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    /**
     * Resize the event by sending a PATCH request to the API.
     */
    async resizeEventDate(eventResizeInfo) {
      let extendedProps = eventResizeInfo.event.extendedProps; // An object holding miscellaneous other properties specified in the Event Object.
      // Check if the event is recurring
      if (extendedProps.recurring) {
        // Show toast that this cannot be done
        this.$toast.add({ severity: 'info', summary: 'Herhaalde activiteit niet gewijzigd', detail: 'U kunt een herhalende activiteiten niet wijzigen op de agenda. Klik op de activiteit om hem te bewerken.', group: 'global' });
        // Revert the resize
        eventResizeInfo.revert();
      }

      // Post new event to the API
      let payload = {};

      // Get event
      let event = eventResizeInfo.event;
      // Get the delta change in time
      payload.startDelta = eventResizeInfo.startDelta;
      payload.endDelta = eventResizeInfo.endDelta;

      // Send request to API
      const response = await fetch('/api/event/'+event.id+'/resize-date', {
        method: 'PATCH',
        credentials: "include", // Set to make sure the cookies are send with the request.
        headers: this.requestHeaders,
        body: JSON.stringify(payload)
      });

      const status_code = response.status;

      if (status_code === 200) {
        // Emit event
        this.$emit('eventResizeChanged');
        return true;
      }

      let response_data = await response.json();
      // Show error message
      this.$toast.add({ severity: 'error', summary: 'Fout', detail: 'De activiteit tijd kon niet aangepast worden.', group: 'errors' });
      // Revert event
      eventResizeInfo.revert();
      return false;

    },
  }
}
</script>

<template>

  <Toast position="top-center" group="global" />

</template>

<style>
 /* See agenda.scss for styling. Styling is here because we want the Gin/Bootstrap variables. */
</style>
